import script from "./OrganizationRoleBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationRoleBadge.vue?vue&type=script&setup=true&lang=js"

export default script